import { DetallePaxParams } from '../interfaces/dashboardOperativoDia'

/**
 * URL del detalle de pasajeros detrás de un indicador o una barra del dashboard del día.
 *
 * `categoria` va con `encodeURIComponent` sí o sí: es la etiqueta que armó el backend —para barcos,
 * el nombre de la embarcación más las fechas de la salida, «Isabela II · 10-14 sep»— y un `&` (o un
 * `#`, o un `+`, o el `·`) concatenado crudo parte el query string, así que el backend recibe una
 * categoría distinta, devuelve cero filas y no hay error ni log que lo delate. Tiene que llegar
 * carácter por carácter como vino: al otro lado se compara contra la misma etiqueta recalculada.
 *
 * Vive en su propio módulo, y no dentro del api, para poder verificarlo sin arrastrar el store:
 * `services/dashboardOperativoDia.services` depende de `baseQuery`, que termina importando el
 * store, y el store vuelve a importar el api.
 */
export const urlDetallePax = ({ fecha, dimension, categoria }: DetallePaxParams): string => {
  const base = `/DashboardOperativoDiaBusiness/Detalle?fecha=${encodeURIComponent(fecha)}&dimension=${dimension}`

  // Los KPI no llevan categoría; el resto de las dimensiones sí, con la etiqueta de su barra.
  return categoria === undefined ? base : `${base}&categoria=${encodeURIComponent(categoria)}`
}

/**
 * URL del resumen del día. `version` es el contador del botón de actualizar: el backend cachea la
 * respuesta 60 s por query string completa, así que cambiar este parámetro obliga a recalcular. En la
 * carga normal no se manda, para que la URL siga siendo la que comparten todos los usuarios.
 */
export const urlResumenDia = (fecha: string, version?: number): string => {
  const base = `/DashboardOperativoDiaBusiness?fecha=${encodeURIComponent(fecha)}`

  return version === undefined || version <= 0 ? base : `${base}&r=${version}`
}
